import * as Sentry from "@sentry/react";
import App from 'app/src/app'
import { AppRegistry } from 'react-native'

// Initialisation de Sentry pour le web
Sentry.init({
  dsn: "https://40a15f4ff73f5b41def1295d995b370a@sentry.jvs-mairistem.dev/33",
  sendDefaultPii: true,
  environment: process.env.NODE_ENV || 'development',
  tracesSampleRate: 1.0,
});

AppRegistry.registerComponent('boilerplate', () => App)
AppRegistry.runApplication('boilerplate', {
  rootTag: document.getElementById('root'),
})
